import { render, staticRenderFns } from "./EstablishmentRoleUpdate.vue?vue&type=template&id=28456eaa&"
import script from "./EstablishmentRoleUpdate.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports